import { format } from "date-fns";
import { ja } from "date-fns/locale";
import i18n from "i18n";

const LOCALE_MAP: {
  [key: string]: (date: Date, dateFormat: string) => string;
} = {
  ja: (date: Date, dateFormat: string): string =>
    format(date, dateFormat, {
      locale: ja,
    }),
  en: (date: Date, dateFormat: string): string => format(date, dateFormat),
};

const formatDate = (date: Date, format: { [key: string]: string }): string => {
  const currentLang = i18n.language;
  const dateFormat = format[currentLang];
  return LOCALE_MAP[currentLang](date, dateFormat);
};

const localizeDateFormat = (zuluIsoDate: string): string => {
  const date = new Date(zuluIsoDate);
  const format = {
    ja: "yyyy年M月d日H時m分",
    en: "yyyy-MM-dd HH:mm:ss",
  };
  return formatDate(date, format);
};

export { formatDate, localizeDateFormat };
